"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpgradeBeaconProxy__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_upgradeBeacon",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_initializationCalldata",
                type: "bytes",
            },
        ],
        stateMutability: "payable",
        type: "constructor",
    },
    {
        stateMutability: "payable",
        type: "fallback",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class UpgradeBeaconProxy__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(_upgradeBeacon, _initializationCalldata, overrides) {
        return super.deploy(_upgradeBeacon, _initializationCalldata, overrides || {});
    }
    getDeployTransaction(_upgradeBeacon, _initializationCalldata, overrides) {
        return super.getDeployTransaction(_upgradeBeacon, _initializationCalldata, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.UpgradeBeaconProxy__factory = UpgradeBeaconProxy__factory;
UpgradeBeaconProxy__factory.bytecode = _bytecode;
UpgradeBeaconProxy__factory.abi = _abi;
//# sourceMappingURL=UpgradeBeaconProxy__factory.js.map